module.exports = __webpack_public_path__ + "static/turquia-017.thumb-7154d26e175111f779cae5ac73bd25e1.jpg";